import { memo } from 'react';
import { AdminFormRow } from '@ui';
import { ControlledHubAutocomplete } from '../../components/selectors/ControlledHubAutocomplete';

type NopHubSelectorProps = {
  isReadOnly?: boolean;
};

export const NopHubSelector = memo(({ isReadOnly }: NopHubSelectorProps) => (
  <AdminFormRow title="NOP Hub" isRequired>
    <ControlledHubAutocomplete name="nopHub" aria-label="NOP Hub" isDisabled={isReadOnly} />
  </AdminFormRow>
));

NopHubSelector.displayName = 'NopHubSelector';
